<template>
    <div>
        <div class="list-filter" v-for="entry in listFilters">
            <p class="list-filter-title">{{ entry.name }}</p>
            <ul class="list-filter-list">
                <li class="list-filter-item"
                    v-for="option in entry.options"
                    :class="{'list-filter-item--active': activeOption(entry, option)}"
                    @click="setFilter(entry, option)">
                    <i v-if="option.icon" :class="option.icon" class="list-filter-icon"></i>
                    {{ option.label }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            listFilters: {
                type: Array
            },
            selectedFilters: {
                type: Object
            },
            allowDeselect: {
                default: true
            }
        },
        mounted () {
            // set default filters
            this.listFilters.forEach(entry => {
                entry.options.forEach(option => {
                    if (option.defaultSelected) {
                        this.setFilter(entry, option)
                    }
                })
            })
        },
        methods: {
            setFilter (entry, option) {
                let newValue = this.selectedFilters[entry.query_param]
                const sameValue = newValue === option.value
                if (!this.allowDeselect && sameValue) {
                    return
                }
                newValue = sameValue ? '' : option.value
                const filter = {
                    query_param: entry.query_param,
                    value: newValue
                }
                this.$emit('setFilter', filter)
            },
            activeOption (entry, option) {
                const entrySelected = this.selectedFilters.hasOwnProperty(entry.query_param)
                const optionSelected = this.selectedFilters[entry.query_param] === option.value
                return entrySelected && optionSelected
            }
        }
    }
</script>
<style lang="scss" scoped>
    .list-filter {
        margin: 25px 0;
        &-title {
            text-transform: uppercase;
            font-weight: 700;
            font-size: 12px;
            color: #666666;
        }

        &-list {
            padding: 0;
            margin: 0;
            list-style-type: none;
        }

        &-icon {
            margin-right: 5px;
        }

        &-item {
            cursor: pointer;
            font-size: 13px;
            color: #666666;
            padding-bottom: 5px;
            margin-bottom: 5px;
            border-bottom: 1px solid #e2e2e2;
            &:last-child {
                border-bottom: 0;
            }
            &--active {
                font-weight: 700;
                color: #333333;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ListFilterComponent.vue?12083278